module.exports = __webpack_public_path__ + "img/7800.5d5485ed.jpg";